import React, { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'

import { useAutoFocus } from '../../../../../core/hooks'
import { CloseButton } from '../../../../../core/components'
import { GuestCount } from './GuestCount/GuestCount'
import { AgeCategoryCount, AgeCategoryType } from '../../../FilterBarTypes'
import { SectionHeader } from '../SectionHeader/SectionHeader'

import './Guests.css'

type Props = {
  ageCategories?: AgeCategoryType[]
  updateGuestsCount: (arg1: string, arg2: number) => void
  ageCategoryCounts: AgeCategoryCount
  autoFocus?: boolean
  onClose?: () => void
}

export const Guests = forwardRef<HTMLDivElement, Props>(
  (
    {
      ageCategories,
      updateGuestsCount,
      ageCategoryCounts,
      autoFocus,
      onClose,
    }: Props,
    ref
  ) => {
    const { t } = useTranslation('filterBar')
    const containerRef = useAutoFocus<HTMLDivElement>(autoFocus)

    return (
      <div id="will-filter-bar-guests" ref={ref}>
        <SectionHeader
          title={t('guests.title')}
          action={onClose && <CloseButton handleClose={onClose} />}
        />

        <div className="will-guests-filter-container" ref={containerRef}>
          {ageCategories?.map((category) => (
            <GuestCount
              key={category.id}
              id={category.id}
              label={category.name}
              minVal={category.minVal}
              sortOrder={category.sortOrder}
              updateGuestsCount={updateGuestsCount}
              count={ageCategoryCounts[`guests-${category.id}`] || 0}
            />
          ))}
        </div>
      </div>
    )
  }
)

Guests.displayName = 'Guests'
